<!-- Html code for AMC contract create-->
<template>
  <div>
    <!-- Header title for page-->
 <RecordNotFound v-if="status_code==404" :message="status_message"></RecordNotFound>
 <template v-else>
    <GlobalHeader title="AMC Contract" @redirectPage="redirectPage"></GlobalHeader>
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <!-- validation for amc contract-->
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="duplicatecode">
            <p class="fw-semi-bold">{{ status_message  }}</p>
          </b-alert>
          <b-alert
            class="alert-transparent alert-danger"
            :show="alertShow= error_show && this.errors.any()"
          >
            <button type="button" @click="error_show=!error_show" class="close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div v-for="item in errors.items" :key="item.id" v-if="item.scope=='amc-contract-form'">
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <b-form
      @submit.prevent="onSubmit('amc-contract-form')"
      data-vv-scope="amc-contract-form"
      class="pb-3"
      style="margin-left:3px;margin-right:3px;"
    >
      <div class="sales-bg pt-30p pb-4 mb-2 border-bottom-dot" style="background:#f7f7f7">
        <!--  customer input block -->
        <b-row>
          <b-col xl="10" lg="10" md="10" sm="10" xs="10" @click="removecustomer">
            <b-form-group>
              <div class="input-group">
                <vue-bootstrap-typeahead
                  v-show="page == 'create'"
                  id="customer_search"
                  class="customer_search customer_search_input bg-white-input"
                  v-model="cus_id"
                  :data="customers"
                  :serializer="customer => customer.label"
                  @hit="checkpos($event)"
                  placeholder="Type to search customer"
                  ref="cus_name_typeahead"
                  title="Enter first three characters of customer to search"
                />
                <input
                  style="border-right:0 !important"
                  type="text"
                  v-if="page == 'update'"
                  class="form-control input_customer_search"
                  :disabled="true"
                  :value="cus_id"
                />
                <div class="input-group-append">
                  <b-input-group-text
                    style="border-right: 0 !important;border-top-right-radius: 0 !important;border-bottom-right-radius: 0 !important;"
                    class="vselect-custom-add-icon ml-0"
                    v-b-tooltip
                    title="Add Customer"
                    v-if="RoutePermission(false,'','','customer','create')"
                    v-b-modal.createcustomer
                  >&#43;</b-input-group-text>

                  <b-dropdown
                    class="advance-search-option btn-radius-unset text-center"
                    size="sm"
                    variant="light"
                    :text="search_value"
                    style="height:32px;"
                  >
                    <b-dropdown-item
                      @click="search_column = 'cus_display_name',search_value='Customer Name'"
                    >Customer Name</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_ph_no_1',search_value='Phone Number'"
                    >Phone Number</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_legacy_id',search_value='Customer ID'"
                    >Customer ID</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_gst_no',search_value='Gst Number'"
                    >Gst Number</b-dropdown-item>
                    <b-dropdown-item
                      @click="search_column = 'cus_pan_no',search_value='PAN Number'"
                    >PAN Number</b-dropdown-item>
                  </b-dropdown>

                  <input
                    type="hidden"
                    v-validate="'required'"
                    data-vv-name="customer"
                    name="cus_id"
                    v-model.trim="field.cus_id"
                  />
                  <span
                    class="ml-2 mt-2"
                    v-b-tooltip
                    title="View Customer Details"
                    v-if="field.cus_id != ''&&RoutePermission(false,'','invoice','customer','index')"
                    @click="toggleCustomerDetails()"
                  >
                    <i class="la la-external-link la-lg"></i>
                  </span>
                </div>
                <span v-if="field.cus_id" class="mt-2 pl-1 cursor_pointer">
                  <b-badge class="form-currency" variant="success" size="xs">{{field.currency_code}}</b-badge>
                </span>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <b-row style="max-width:1000px;" class="mt-4">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group label-class="required" label="Product" label-for="name" class="pb-3">
            <v-select
              :clearable="false"
              :disabled="page == 'update' && list.header_details.total_used_qty > 0"
              @input="displayavailableservice($event)"
              id="amc-pdt-select"
              size="sm"
              v-model.trim="field.pdt_id"
              :options="amc_pdt_list"
              name="pdt_id"
              data-vv-name="product"
              index="value"
              label="label"
              v-validate="'required'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <!-- AMC amount -->
          <b-form-group label-class="required" label="Amount" label-for="amount" class="mb-3">
            <input
              :disabled="page == 'update' && list.header_details.is_generate == 1"
              @blur="roundOff(field.amc_total)"
              type="text"
              size="sm"
              data-vv-name="AMC amount"
              v-validate="'required|min:0'"
              class="account form-control"
              v-model.trim="field.amc_total"
              name="amc_total"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            :label="'Start on'"
            label-class="required"
            label-for="invoice_date"
            class="mb-3"
          >
            <DatePicker
              :format="$AppDetails.organization.date_format"
              lang="en"
              input-class="form-control"
              @change="selectDate($event,'amc_start_date')"
              style="width:100% !important;"
              name="amc_start_date"
              v-model.trim="field.amc_start_date"
              data-vv-name="start date"
              :not-after="field.amc_end_date!=''?field.amc_end_date:field.next_service_date"
              v-validate="'required'"
              placeholder=" "
            >
              <i class="fa fa-calendar text-dark" slot="calendar-icon" />
            </DatePicker>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            label-class="required"
            label="Ends on"
            label-for="invoice_date"
            class="mb-3"
          >
            <DatePicker
              class="mb-1"
              :format="$AppDetails.organization.date_format"
              lang="en"
              input-class="form-control"
              name="amc_end_date"
              v-model.trim="field.amc_end_date"
              :not-before="field.next_service_date!=''?field.next_service_date:field.amc_start_date"
              v-validate="'required|date_format:yyyy-MM-dd'"
              @change="selectDate($event,'amc_end_date')"
              style="width:100% !important;"
              data-vv-name="end date"
              placeholder=" "
            >
              <i class="fa fa-calendar text-dark" slot="calendar-icon" />
            </DatePicker>
            <span class="mt-1 pt-1">{{ next_renewal_date }}</span>

            <div class="abc-checkbox mt-2">
              <input
                type="checkbox"
                id="enable_auto_renewal"
                name="enable_auto_renewal"
                v-model.trim="field.enable_auto_renewal"
                true-value="1"
                false-value="0"
              />
              <label for="enable_auto_renewal" style="padding-top:2px;">Enable Auto renewal</label>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8" v-if="field.enable_auto_renewal == 1">
          <b-form-group
            :label="'Renew After'"
            label-for="Renew After"
            label-class="required"
            class="mb-3"
          >
            <div style="display:flex;justify-content:space-between">
              <div>
                <select
                  style="width:125px;"
                  id="repeat_every"
                  v-validate="this.field.enable_auto_renewal=='1'? 'required':''"
                  class="form-control"
                  name="repeat_every"
                  data-vv-name="renewal period"
                  v-model.trim="field.repeat_every"
                  @change="recurring_period($event)"
                >
                  <option selected></option>
                  <option
                    v-for="item in repeat_every"
                    :key="item.value"
                    :value="item.value"
                  >{{ item.label }}</option>
                </select>
                <!-- <v-select
                          style="width:110px;"
                          id="repeat_every"
                          v-validate="this.field.enable_auto_renewal=='1'? 'required':''"
                          size="sm"
                          :options="repeat_every"
                          label="label"
                          name="repeat_every"
                          data-vv-name="renewal period"
                          @change="recurring_period($event)"
                          v-model.trim="field.repeat_every"
                ></v-select>-->
              </div>
              <template v-if="custom_recurring_period == 1">
                <div>
                  <b-form-input
                    style="border-left: 0 !important;border-right: 0 !important;border-radius:0 !important;height:32px !important"
                    type="text"
                    size="sm"
                    name="repeat category"
                    data-vv-name="repeat category value"
                    v-model.trim="field.repeat_every_day"
                    v-validate="( (this.field.repeat_every_cat == 'Week' ? 'max_value:52|required' : (field.repeat_every_cat == 'Day' ? 'max_value:365|required' : (field.repeat_every_cat == 'Year' ? 'max_value:1|required' :(this.custom_recurring_period=='1'?'required': 'max_value:12')))))+'|min_value:1'"
                  />
                </div>
                <div>
                  <b-form-select
                    :style="custom_recurring_period == 1?'border-top-left-radius:0 !important;border-bottom-left-radius:0 !important;width:90px':'width:90px'"
                    class="form-control"
                    v-model.trim="field.repeat_every_cat"
                    name="repeat_every_cat"
                    data-vv-name="repeat category"
                    v-validate=" this.field.repeat_every_day!='' ? 'required':''"
                  >
                    <option value="Week">Week(s)</option>
                    <option value="Day">Day(s)</option>
                    <option value="Month">Month(s)</option>
                    <option value="Year">Year(s)</option>
                  </b-form-select>
                </div>
              </template>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="max-width:840px" class="mt-4 mb-2 pt-2">
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
            v-b-toggle.collapse-2
          >
            Other details
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>
      <b-collapse id="collapse-2" visible>
        <b-row style="max-width:1000px;">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="Sales Person" label-for="name" class="mb-3">
              <b-input-group class="vselect-custom-add">
                <template slot="append">
                  <b-input-group-text
                    v-b-tooltip
                    title="Add Sales Person"
                    class="vselect-custom-add-icon"
                    v-on:click="callsalespersonmodal({sales_person_id:'',sales_person_name:'',sales_person_mail:'',sales_person_ph_no:''})"
                  >&#43;</b-input-group-text>
                </template>
                <template slot="prepend">
                  <v-select
                    :clearable="field.sales_person_id!=''&&field.sales_person_id!=null"
                    @input="$event==null?field.sales_person_id='':''"
                    size="sm"
                    class="form-vselect"
                    :options="sales_person_list"
                    label="label"
                    index="value"
                    id="salesperson-select"
                    v-model.trim="field.sales_person_id"
                    name="sale_per"
                  >
                    <template slot="option" slot-scope="option">
                      <div class="d-flex w-100 v-select-option" :title="option.label">
                        <div class="text-truncate" style="width:292px">{{ option.label }}</div>
                        <span class="select-hover-block">
                          <span
                            class="la la-edit la-lg float-right"
                            v-on:click.stop="callsalespersonmodal({sales_person_id:option.value,sales_person_name:option.label,sales_person_mail:option.sales_person_mail,sales_person_ph_no:option.sales_person_ph_no})"
                          ></span>
                          <span
                            class="glyphicon glyphicon-trash float-right pl-2"
                            v-on:click.stop="salespersondelete=true,calldeletemodal(option.value)"
                          ></span>
                        </span>
                      </div>
                    </template>
                  </v-select>
                </template>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group :label="'Reference No'" label-for="ref-no" class="mb-3">
              <input
                type="text"
                size="sm"
                class="account form-control"
                v-model.trim="field.ref_no"
                name="ref_no"
                data-vv-name="reference no"
                v-validate="'max:30'"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row style="max-width:1000px;">
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group label="First Service on" label-for="next_service_date">
              <DatePicker
                :format="$AppDetails.organization.date_format"
                lang="en"
                input-class="form-control"
                @change="selectDate($event,'next_service_date')"
                style="width:100% !important;"
                name="next_service_date"
                v-model.trim="field.next_service_date"
                :not-after="field.amc_end_date"
                :not-before="field.amc_start_date"
                v-validate="'date_format:yyyy-MM-dd'"
                data-vv-name="next service date"
                placeholder=" "
              >
                <i class="fa fa-calendar text-dark" slot="calendar-icon" />
              </DatePicker>
            </b-form-group>
          </b-col>

          <b-col cols="12" lg="5" md="6" sm="8">
            <span class="display-flex fw-semi-bold mt-4 pt-2" v-if="field.is_export == 2">
              <span
                v-if=" currency_details.exchange_rate_date!=''||org_details.exchange_rate_status==0"
              >
                <small v-if="changed_currency==false" class="d-block">Exchange rate as on creation,</small>
                <small
                  v-else
                  class="d-block"
                >As of Date: {{currency_details.exchange_rate_date!=''?getDateFormat(currency_details.exchange_rate_date):getDateFormat(field.amc_start_date)}}</small>
                <span style="font-size:11px;">
                  1 {{field.currency_code}} = {{parseFloat(field.unit_currency_value)}} {{orgCurrency}}
                  <span>
                    <b-dropdown
                      left
                      toggle-class="p-0 text-decoration-none"
                      variant="link"
                      no-caret
                      size="xs"
                      ref="exchange_rate_dropdown"
                    >
                      <template slot="button-content">
                        <i
                          class="la la-edit la-lg theme-text-color pl-1"
                          style="top:-2px;position:relative"
                          @click="exchange_rate_details={ currency_exchange_rate: field.unit_currency_value , save_exchange_rate: 0, recalc: 0 }"
                        ></i>
                      </template>
                      <b-dropdown-header>Edit Exchange Rate</b-dropdown-header>
                      <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-form class="p-3" style="width:250px;">
                        <b-row>
                          <b-col>
                            <b-form-group
                              :label="'Exchange Rate(in '+orgCurrency+')'"
                              label-class="required"
                              label-for="ex-rate"
                            >
                              <b-input
                                @blur="exchange_rate_details.currency_exchange_rate = exchange_rate_details.currency_exchange_rate==''||parseFloat(exchange_rate_details.currency_exchange_rate) <=  0||parseFloat(exchange_rate_details.currency_exchange_rate) >  100000000000000||isNaN(parseFloat(exchange_rate_details.currency_exchange_rate))? 1 : parseFloat(exchange_rate_details.currency_exchange_rate)"
                                v-model="exchange_rate_details.currency_exchange_rate"
                              ></b-input>
                            </b-form-group>
                            <b-checkbox
                              v-if="org_details.exchange_rate_status==1&&page=='create'"
                              unchecked-value="0"
                              value="1"
                              v-model="exchange_rate_details.save_exchange_rate"
                              class="mt-2"
                            >
                              <small>Set this rate as default for {{getDateFormat(field.amc_start_date)}}</small>
                            </b-checkbox>
                            <b-checkbox
                              unchecked-value="0"
                              value="1"
                              v-model="exchange_rate_details.recalc"
                              class="mt-2"
                            >
                              <small>Re-calculate item prices based on this rate</small>
                            </b-checkbox>
                          </b-col>
                        </b-row>
                        <b-row class="mt-3">
                          <b-col>
                            <b-button variant="primary" size="xs" @click="exchangeRateSubmit()">Save</b-button>
                          </b-col>
                        </b-row>
                      </b-dropdown-form>
                    </b-dropdown>
                  </span>
                </span>
              </span>
              <template v-else>
                <b-form-group
                  label="Exchange rate"
                  label-class="required"
                  label-cols="4"
                  label-for="currency"
                >
                  <b-input-group
                    size="sm"
                    :append="orgCurrency"
                    :prepend="'1 '+getDetails(
                    this.$AppDetails.currency_details,
                    field.cus_currency,
                    'currency_code'
                    ) +' = '"
                  >
                    <b-form-input
                      @blur="changeExchangeRate()"
                      type="text"
                      class="text-right"
                      v-model.trim="field.unit_currency_value"
                      name="Currency"
                      data-vv-name="currency"
                      v-validate="'required|decimal:5|excluded:'+parseFloat(0).toFixed(2)+'|min_value:0'"
                    ></b-form-input>
                  </b-input-group>
                  <small
                    v-if="org_details.exchange_rate_status==1&&page!='update'"
                    class="text-muted"
                  >This will be set as the exchange rate for this date.</small>
                </b-form-group>
              </template>
            </span>
          </b-col>
        </b-row>
        <b-row style="max-width:1000px;">
          <b-col cols="12" lg="10" md="12" sm="12" class="mt-2">
            <b-form-group label="Contract Tags" label-for="tags-select" class="mb-3">
              <b-input-group class="vselect-custom-add">
                <template slot="append">
                  <b-input-group-text
                    class="vselect-custom-add-icon"
                    v-b-tooltip
                    title="Add Tags"
                    v-on:click="contracttags=true,updatetag=false,calltagmodal({tag_id:'',tag_name:''})"
                  >&#43;</b-input-group-text>
                </template>
                <template slot="prepend">
                  <v-select
                    :clearable="false"
                    multiple
                    size="sm"
                    :options="tag_list"
                    label="label"
                    index="value"
                    id="tags-select"
                    v-model.trim="field.amc_tags"
                  >
                    <template slot="option" slot-scope="option">
                      <div class="d-flex w-100 v-select-option" :title="option.label">
                        <div
                          class="text-truncate"
                          style="width:calc(100% - 40px)"
                        >{{ option.label }}</div>
                        <span class="select-hover-block">
                          <span
                            class="la la-edit la-lg float-right"
                            v-on:click.stop="contracttags=true,updatetag=true,calltagmodal({tag_id:option.value,tag_name:option.label})"
                          ></span>
                          <span
                            class="glyphicon glyphicon-trash float-right pl-2"
                            v-on:click.stop="contractdeletetag=true,calldeletemodal(option.value)"
                          ></span>
                        </span>
                      </div>
                    </template>
                  </v-select>
                </template>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-collapse>
      <b-row
        style="max-width:1170px;"
        class="mt-4 mb-2 pt-2"
        v-if="amc_settings_details.custom_field.length > 0"
      >
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
            v-b-toggle.collapse-1
          >
            Custom fields
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>
      <b-collapse id="collapse-1" visible>
        <b-row style="max-width:1000px;">
          <b-col
            cols="12"
            lg="5"
            md="6"
            sm="8"
            :key="index"
            v-for="(custom_field,index) in amc_settings_details.custom_field"
            v-if="custom_field.status == 1 && custom_field.permissions == 'write'"
          >
            <CustomPreview
              v-on:assigncustomvalue="assigncustomvalue($event)"
              :custom="custom_field"
              :disabled="false"
              :modelname="field[custom_field.field_name]"
            />
            <input
              type="hidden"
              :name="custom_field.label_name"
              :data-vv-name="custom_field.label_name"
              v-validate="custom_field.validation"
              v-model="field[custom_field.field_name]"
            />
          </b-col>
        </b-row>
      </b-collapse>
      <div class="mt-5 pb-5" v-if="field.pdt_id != ''">
        <b-row style="max-width:1200px;">
          <b-col xl="12" lg="12" md="12" sm="12" xs="12">
            <!-- Table for AMC products -->
            <table class="table table-bordered sales-table last-child-border-none total-table">
              <thead>
                <!-- <th width="1%"></th> -->
                <th width="25%">Product details</th>
                <!-- <th>Description</th> -->
                <th width="10%" class="text-right">Quantity</th>
                <th width="10%" class="text-right">Selling Price</th>
                <!-- <th width="10%" class="text-right">Purchase price</th> -->
                <th width="1%"></th>
              </thead>
              <tbody>
                <!-- Product index -->
                <tr v-for="(item,index) in items" :key="index">
                  <!-- <td>{{ index + 1 }}</td> -->
                  <td @click="removeproduct($event,index)" class="show-product-details">
                    <!-- Product search -->
                    <vue-bootstrap-typeahead
                      style="width:100%"
                      @input="productlist($event,index)"
                      v-model="item.pdt_detail_id"
                      :id="'product_search_'+index"
                      name="pdt_detail_id[]"
                      :data="item.products"
                      :class="{'is-invalid': errors.has('pdt_id'),'mr-3':true,'table-form-search':true,'product_search':true}"
                      :serializer="product => product.label+' '+product.pdt_legacy_id+' '+product.pdt_sku"
                      @hit="checkSalePrice($event,index)"
                      placeholder="Type to search product"
                      :ref="'pdt_name_typeahead_'+index"
                    >
                      <template slot="suggestion" slot-scope="{ data, htmlText }">
                        <span>{{ data.label }}</span>
                        <br />

                        <small class="pr-3" v-if="data.pdt_legacy_id">{{data.pdt_legacy_id }}</small>
                        <small>{{ data.pdt_sku }}</small>
                      </template>
                    </vue-bootstrap-typeahead>
                    <span
                      class="float-right table-custom-add-icon cursor_pointer"
                      title="Add Product"
                      v-if="RoutePermission(false,'','','product','create')"
                      v-b-modal.createproduct
                      v-on:click="item_id = index"
                    >&#43;</span>
                    <b-form-input
                      v-show="false"
                      type="text"
                      size="sm"
                      :name="'pdt_id['+index+']'"
                      v-model.trim="item.pdt_id"
                      v-validate="'required'"
                      :data-vv-name="'row '+(index +1)+' product'"
                    />
                    <!--
                        HSN/SAC code
                        <small class="theme-text-color">
                          HSN / SAC:
                          <input
                            v-validate="'max:20'"
                            type="text"
                            :name="'pdt_hsn['+index+']'"
                            v-model.trim="item.pdt_hsn"
                             :data-vv-name="'row '+(index +1)+' HSN/SAC'"
                            style="border:none;background-color:rgb(247, 247, 247)"
                          />
                    </small>-->
                    <!-- Description -->
                    <!-- <textarea
                          v-validate="'max:255'"
                          class="form-control mt-1 item_table_desc"
                          :name="'pdt_desc['+index+']'"
                          v-model.trim="item.pdt_desc"
                           :data-vv-name="'row '+(index +1)+' product description'"
                          rows="3"
                    ></textarea>-->
                  </td>
                  <!-- Product quantity -->
                  <td>
                    <input
                      v-model.trim="item.pdt_qty"
                      :name="'quantity in row '+ (parseInt(index) +1)"
                      v-validate="'required|decimal:2|min_value:'+item.pdt_used_qty"
                      :class="{ 'form-control': true,'is-invalid': errors.has('pdt_qty')}"
                      :style=" errors.has('pdt_qty['+index+']') ? 'border:1px red solid !important' : ''"
                      type="text"
                      id="pdt_qty"
                      class="text-right"
                      :data-vv-name="'row '+(index +1)+' product quantity'"
                    />
                    <small class="float-right theme-text-color"></small>
                  </td>
                  <!-- Selling price -->
                  <td>
                    <b-form-input
                      type="text"
                      :disabled="true"
                      id="selling_price"
                      class="text-right"
                      :name="'sale_price['+index+']'"
                      v-model.trim="item.sale_price"
                    />
                  </td>
                  <!-- Purchase price -->
                  <!-- <td>
                        <b-form-input
                          type="text"
                          :disabled="true"
                          id="purchase_price"
                          class="text-right"
                          :name="'purchase_price['+index+']'"
                          v-model.trim="item.purchase_price"
                        />
                  </td>-->
                  <!-- Icon for remove row -->
                  <td>
                    <i
                      class="glyphicon glyphicon-trash mt-2"
                      v-if="item.pdt_used_qty == 0"
                      @click="removeRow(index)"
                    ></i>
                  </td>
                </tr>
              </tbody>
              <tbody class="no-border">
                <tr>
                  <td class="no-border" style="padding-top:5px !important">
                    <span
                      class="addline theme-text-color cursor_pointer"
                      @click="addNewRow()"
                    >Add Lines</span>
                    <span class="float-right fw-semi-bold mr-3">Total</span>
                  </td>
                  <td class="no-border">
                    <span
                      class="float-right fw-semi-bold mr-3"
                      style="padding-top:5px !important"
                    >{{ Number(total().total_pdt_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                  </td>
                  <td class="no-border">
                    <span class="float-right fw-semi-bold mr-3" style="padding-top:5px !important">
                      {{getDetails(
                      $AppDetails.currency_details,
                      (field.cus_currency || $AppDetails.organization.org_currency),
                      "currency_symbol"
                      )+" "+ Number(total().total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </div>

      <div class="footer" style="box-shadow:0 -4px 5px -3px #ccc;">
        <div :class="{'form-action' : true}">
          <b-button
            type="submit"
            :variant="page == 'update' ? 'primary' : 'primary'"
            class="btn-rounded mr-3"
            :disabled="submitted"
          >
            <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>
            {{ page == "update" ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-form>
    <TagModal
      v-if="contracttags"
      :tag_id="modal_tag_id"
      module="amccontract"
      v-on:setMultipleAddedRef="getMultipleAddedRef"
    ></TagModal>
    <SalesPersonModal :sales_person_id="modal_sales_person_id" v-on:setAddedRef="getAddedRef"></SalesPersonModal>
    <DeleteDropdown
      v-if="contractdeletetag || salespersondelete"
      id="contract-dropdown-delete"
      :content="'Are you sure you want to delete this'+(salespersondelete?' sales person ?':' selected tag ?')"
      module="general"
      :method="contractdeletetag?'salestagdelete':'salespersondelete'"
      v-on:setDropdownDelete="getDropdownDelete"
      :value="deletedropdownid"
    ></DeleteDropdown>
    <!-- Call product modal -->
    <CustomerModal
      v-on:setCustomerValue="getCustomerValue($event)"
      v-if="RoutePermission(false,'','','customer','create')"
    ></CustomerModal>
    <ProductModal
      v-on:setProductValue="getProductValue($event)"
      module="amcservice"
      :item-id="item_id"
    ></ProductModal>
    <ShowCustomerDetails v-if="customer_details == 1"></ShowCustomerDetails>
    <!-- Modal for change exchange rate value change warning message -->
    <ExchangeRateWarning></ExchangeRateWarning>
 </template>
  </div>
</template>
<script>
import moment from "moment"; // to control date format
import getPageTitle from "@/utils/get-page-title"; // to set page title
import CustomPreview from "@/components/Form/Settings/CustomPreview";
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import VueBootstrapTypeahead from "vue-bootstrap-typeahead"; // data on search api calls
import SalesPersonModal from "@/components/Modal/SalesPersonModal"; // sales person modal
import $ from "jquery"; // for using jquery function
import vSelect from "vue-select"; // searchable select dropdwon
import DatePicker from "vue2-datepicker"; // vue datepicker
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
import RecordNotFound from "@/pages/Error/RecordNotFound";
import CustomerModal from "@/components/Modal/CustomerModal"; // customer modal
import ProductModal from "@/components/Modal/ProductModal"; // product modal
import TagModal from "@/components/Modal/TagModal"; // tag modal
import DeleteDropdown from "@/components/Modal/DeleteDropdown";
import ShowCustomerDetails from "@/components/Form/Customer/ShowCustomerDetails";
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import ExchangeRateWarning from "@/components/Modal/ExchangeRateWarning"; //for Exchange rate change warning message in modal
export default {
  props: ["page", "duplicatecode", "submitted"],
  mixins: [formatDate], // call the glbal mixin fucntion
  components: {
    vSelect,
    CustomPreview,
    CustomerModal,
    ProductModal,
    VueBootstrapTypeahead, // on change api
    DatePicker,
    DeleteDropdown,
    RecordNotFound,
    ShowCustomerDetails,
    TagModal, // tag create modal
    SalesPersonModal,
    ExchangeRateWarning //modal component for exchange rate changes
  },
  data() {
    return {
      contracttags: false,
      amcCollapse: "",
      updatetag: false,
      contractdeletetag: false,
      search_value: "Customer Name",
      search_column: "cus_display_name",
      old_amc_itm_ids: "",
      deletedropdownid: "",
      item_id: "", // item id for product create modal
      cus_id: "", // wathc api dropdown data
      modal_tag_id: {},
      index: [],
      products: [],
      modal_sales_person_id: {}, // variable for sales person id modal
      customers: [], // store the details of selected custoemr
      custom_recurring_period: 0,
      alertShow: "", // to show the error message
      error_show: false, // to show the error message
      field: this.createFreshEventObject(), // header detail data initialize
      update_price: "",
      repeat_every: [
        // value for repaet every dropwon
        { value: "1 Week", label: "1 Week" },
        { value: "2 Week", label: "2 Weeks" },
        { value: "1 Month", label: "1 Month" },
        { value: "2 Month", label: "2 Months" },
        { value: "3 Month", label: "3 Months" },
        { value: "6 Month", label: "6 Months" },
        { value: "1 Year", label: "1 Year" },
        { value: "1", label: "Custom" }
      ],
      items: [
        {
          pdt_used_qty: 0,
          amc_itm_id: "",
          pdt_hsn: "",
          unit_name: "",
          pdt_desc: "",
          pdt_detail_id: "",
          products: [],
          pdt_id: "",
          pdt_qty: 1,
          unit_price: 0,
          sale_price: 0,
          purchase_price: 0
        }
      ],
      customer_details: 0,
      old_cus_id: "",
      old_currency_code: "",
      changed_currency: true,
      exchange_rate_details: {
        currency_exchange_rate: 1,
        save_exchange_rate: 0,
        recalc: 0
      },
      old_exchange_rate: 1,
      salespersondelete: false
    };
  },
  methods: {
    redirectPage(){
              if(this.$route.query.customer_id){
                this.$router.push({name:'CustomerView',params:{id:this.$route.query.customer_id}})
              }
               else if(this.$route.query.page_from=='view'&&(this.$route.params.id||this.$route.query.old_id)){
                 this.$router.push({name:'AmcContractView',params:{id:this.$route.params.id||this.$route.query.old_id
                 }})
               }
                else {
        if (this.$store.state.amccontract.amccontract_index_history) {
          this.$router.push(this.$store.state.amccontract.amccontract_index_history);
        } else {
          this.$router.push({ name: "AmcContract" });
        }
      }
    },

    //  assign custom value
    assigncustomvalue(ev) {
      this.field[ev.field] = ev.value;
    },
    //Customer details
    async toggleCustomerDetails() {
      if (this.customer_details == 0) {
        await this.$store
          .dispatch("customer/fetchViewList", this.field.cus_id)
          .then((response) => {
            if(response.data.code==200){
                this.customer_details = 1;
            }
            else{
                 window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: response.data.status,
              type: response.data.type,
              showCloseButton: true
            });
            }
           });
        await EventBus.$emit("toggleCustomerDetails");
      } else {
        await EventBus.$emit("toggleCustomerDetails");
      }
    },
    roundOff() {
      this.field.amc_total =
        typeof this.field.amc_total != undefined &&
        !isNaN(this.field.amc_total) &&
        this.field.amc_total != ""
          ? parseFloat(this.field.amc_total).toFixed(2)
          : parseFloat(0).toFixed(2);
    },
    //  add the newly added fields
    getAddedRef(ev) {
      this.field.sales_person_id = "";
      this.field.sales_person_id = this.updatedtag_id;
    },
    //  to find particular json value
    getPresentValue(arr, prop, val, field) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i][field];

          break;
        }
      }
      return hasMatch;
    },
    //  to display avalilabel amc service
    async displayavailableservice(event) {
      // this.items = [
      //   {
      //     pdt_used_qty: 0,
      //     amc_itm_id: "",
      //     pdt_hsn: "",
      //     unit_name: "",
      //     pdt_desc: "",
      //     pdt_detail_id: "",
      //     products: [],
      //     pdt_id: "",
      //     pdt_qty: 1,
      //     unit_price: 0,
      //     sale_price: 0,
      //     purchase_price: 0
      //   }
      // ];
      this.items = [];
      if (event != "") {
        var data = {
          value: event
        };
        await this.$store
          .dispatch("amccontract/displayavailableservice", data)
          .then(() => {
            //  item details
            this.field.amc_total = this.serviceTotal;
            this.items = this.service;
            //update prodcut price
            this.$nextTick(function() {
              var i;
              for (i = 0; i < this.items.length; i++) {
                var pdt_name = "pdt_name_typeahead_" + i;
                this.$refs[pdt_name][0].inputValue = this.items[i].products[
                  i
                ].label;
                var cus_currency =
                  !isNaN(this.field.unit_currency_value) &&
                  this.field.unit_currency_value != 0
                    ? this.field.unit_currency_value
                    : 1;

                if (this.field.is_export == 2) {
                  this.items[i].unit_price = parseFloat(
                    parseFloat(this.items[i].unit_price) /
                      parseFloat(cus_currency)
                  ).toFixed(2);
                }
                $("#product_search_" + i + " input").css(
                  "pointer-events",
                  "none"
                );
                $("#product_search_" + i + " input").css(
                  "background-color",
                  "#f7f7f7"
                );
                $("#product_search_" + i + " input").css(
                  "position",
                  "relative"
                );
                $("#product_search_" + i + " .input-group").append(
                  "<span class='la la-close p-2 mt-1 ' id='product_remove_" +
                    i +
                    "'></span>"
                );
                $("#product_remove_" + i).css("position", "absolute");
                $("#product_remove_" + i).css("right", "0");
                $("#product_remove_" + i).css("padding", "10px 6px");
              }
            });
          });
      }
    },
    // call tag nodal
    async calltagmodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "addTag");
        this.modal_tag_id = val;
      });
    },

    //  get the product details on search
    productlist(event, index) {
      if (event != "") {
        this.$store
          .dispatch(
            "general/fetchProductData",
            JSON.stringify({ field: event, pdt_type: "sales" })
          )
          .then(() => {
            this.items[index].products = this.product_filter_list;
          });
      }
    },
    //  remove the design of removed customer
    removecustomer(e) {
      if (e.target.matches("#customer_remove")) {
        this.customer_details = 0;
        $("#customer_search input").css("pointer-events", "all");
        $("#customer_search input").css("background-color", "#fff");
        $("#customer_search input").css("position", "");
        $("#customer_remove").remove();
        this.$refs.cus_name_typeahead.inputValue = "";
        this.old_cus_id = this.field.cus_id;
        this.old_currency_code = this.field.currency_code;
        this.old_exchange_rate = this.field.unit_currency_value;
        this.field.cus_id = "";
        this.field.place_of_supply = "";
      }
    },
    //  get the product created in modal and selected in dropdown
    getProductValue(event) {
      var index = event[0].index;
      var values = event[0];
      $("#product_search_" + index + " input").css("position", "");
      $("#product_remove_" + index).remove();
      var pdt_name = "pdt_name_typeahead_" + index;
      this.$refs[pdt_name][0].inputValue = event[0].label;
      this.items[index].pdt_qty = 1;
      this.items[index].pdt_id = event[0].value;
      this.items[index].products = event;
      //  pass the details to sales rprice modal
      this.checkSalePrice(
        {
          value: values.value,
          label: values.label,
          pdt_sal_price: values.pdt_sal_price,
          pdt_tax_id: values.pdt_tax_id,
          pdt_inter_tax_id: values.pdt_inter_tax_id,
          pdt_hsn: values.pdt_hsn,
          pdt_desc: values.pdt_desc,
          unit_name: values.unit_name
        },
        index
      );
    },
    checkSalePrice(event, index) {
      $("#product_search_" + index + " input").css("pointer-events", "none");
      $("#product_search_" + index + " input").css(
        "background-color",
        "#f7f7f7"
      );
      $("#product_search_" + index + " input").css("position", "relative");
      $("#product_search_" + index + " .input-group").append(
        "<span class='la la-close bg-white pdt-close' id='product_remove_" +
          index +
          "'></span>"
      );
      $("#product_remove_" + index).css("position", "absolute");
      $("#product_remove_" + index).css("right", "0");
      $("#product_remove_" + index).css("padding", "10px 6px");
      if (this.update_price == true) {
        if (event.value != null) {
          var pdt_name = "pdt_name_typeahead_" + index;
          this.$refs[pdt_name][0].inputValue = event.label;
          this.items[index].pdt_id = event.value; // assing the selcted product id to pdt_id modal
          this.items[index].unit_price = event.pdt_sal_price; // get unit price of the selected product
          var cus_currency =
            !isNaN(this.field.unit_currency_value) &&
            this.field.unit_currency_value != 0
              ? this.field.unit_currency_value
              : 1;

          if (this.field.is_export == 2) {
            this.items[index].unit_price = parseFloat(
              parseFloat(this.items[index].unit_price) /
                parseFloat(cus_currency)
            ).toFixed(2);
          }

          this.items[index].pdt_hsn = event.pdt_hsn; // get the pdt hsn of the selected product
          this.items[index].unit_name = event.unit_name; // get the pdt hsn of the selected product
          this.items[index].pdt_desc = event.pdt_desc; // get the pdt hsn of the selected product
        }
      }
    },
    //  call delete dropdown modal
    calldeletemodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "contract-dropdown-delete");
        this.deletedropdownid = val;
      });
    },
    getDropdownDelete(ev) {
      if (ev == 200) {
        if (this.salespersondelete) {
          this.field.sales_person_id =
            this.field.sales_person_id == this.deletedropdownid
              ? ""
              : this.field.sales_person_id;
        } else if (this.field.amc_tags != []) {
          var index = this.field.amc_tags.indexOf(this.deletedropdownid);
          if (index != -1) {
            this.field.amc_tags.splice(index, 1);
          }
        }
      }
      if (ev) {
        this.contractdeletetag = false;
        this.deletedropdownid = "";
        this.salespersondelete = false;
        return;
      }
    },
    // add the newly added fields
    getMultipleAddedRef(ev) {
      if (ev.close) {
        this.contracttags = false;
        return;
      }
      var value = this.updated_tag;
      if (this.updatetag != true) {
        this.field.amc_tags.push(value);
      }
    },

    //Recurring peripod select
    recurring_period(event) {
      if (event.target != "") {
        if (event.target.value == 1) {
          this.custom_recurring_period = 1;
        } else {
          this.custom_recurring_period = 0;

          var repeat_every = event.target.value.split(" ");
          this.field.repeat_every_day = repeat_every[0];
          this.field.repeat_every_cat = repeat_every[1];
        }
      }
    },

    //  call sales person modal
    callsalespersonmodal(val) {
      this.$root.$emit("bv::show::modal", "addSalesPerson");
      this.modal_sales_person_id = val;
    },
    //change exchange rate
    async changeExchangeRate() {
      await this.recalcUnitPrice(this.field.unit_currency_value);
      this.old_exchange_rate = this.field.unit_currency_value;
      this.field.unit_currency_value =
        parseFloat(this.field.unit_currency_value) <= 0 ||
        this.field.unit_currency_value == ""
          ? 1
          : this.field.unit_currency_value;
    },
    // get exchange rate value with transcation date
    getExchangeRateValue(date_change) {
      this.$store
        .dispatch("customer/getCurrencyRate", {
          id: this.field.cus_id,
          currency_id: this.field.cus_currency,
          date: this.field.amc_start_date
        })
        .then(() => {
          this.field.unit_currency_value =
            this.currency_details.currency_exchange_rate != "" &&
            this.currency_details.currency_exchange_rate > 0
              ? this.currency_details.currency_exchange_rate
              : this.currency_details.currency_code == this.orgCurrency
              ? 1
              : this.old_exchange_rate;
          this.field.currency_code = this.currency_details.currency_code;
          if (this.old_cus_id != this.field.cus_id) {
            this.changed_currency = true;
            this.recalcUnitPrice(this.field.unit_currency_value);
            this.old_exchange_rate = this.field.unit_currency_value;
            if (
              this.field.currency_code != this.orgCurrency &&
              this.old_currency_code != ""
            ) {
              if (this.items.some(x => x.pdt_id != "") && date_change != 1) {
                this.$root.$emit("bv::show::modal", "cus_change_exchange_rate");
              }
            }
          } else {
            this.changed_currency = this.page == "update" ? false : true;
          }
        });
    },
    // currency exchange rate dropdown form submit
    exchangeRateSubmit() {
      if (this.exchange_rate_details.save_exchange_rate == 1) {
        var data = {
          currency_id: this.field.cus_currency,
          date: this.field.amc_start_date,
          value: this.exchange_rate_details.currency_exchange_rate,
          code: this.field.currency_code
        };
        data = JSON.stringify(data);
        this.$store.dispatch("currency/addExchangeRate", data).then(() => {
          this.submitted = false;
          if (this.exchange_rate_type == "success") {
            this.error_msg = false;
            //to show the alert message for success or error after api call
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.exchange_rate_message,
              type: this.exchange_rate_type,
              showCloseButton: true
            });
          } else {
            this.error_msg = true;
          }
        });
      }
      if (
        this.exchange_rate_details.recalc == 1 &&
        this.field.unit_currency_value !=
          this.exchange_rate_details.currency_exchange_rate
      ) {
        this.recalcUnitPrice(this.exchange_rate_details.currency_exchange_rate);
      }
      this.old_exchange_rate = this.exchange_rate_details.currency_exchange_rate;
      this.field.unit_currency_value = this.exchange_rate_details.currency_exchange_rate;
      // hide dropdown exchange_rate_dropdown
      this.$refs.exchange_rate_dropdown.hide(true);
    },
    // recalculate unit price of products with exchange rate
    recalcUnitPrice(currency_rate) {
      var temp = this;
      this.items.map(function(value) {
        if (value.pdt_id != "") {
          value.unit_price = parseFloat(
            (parseFloat(temp.old_exchange_rate) *
              parseFloat(value.unit_price)) /
              parseFloat(currency_rate)
          ).toFixed(2);
        }
      });
    },
    //onsubmit function
    onSubmit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          //  send the json data
          var data = JSON.stringify({
            header_details: this.field,
            item_details: this.items,
            old_amc_itm_ids: this.old_amc_itm_ids
          });

          this.$emit("onSubmit", data);
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // validate the form if fail
        }
      });
      return false;
    },
    createFreshEventObject() {
      return {
        cus_currency: "",
        is_export: 1,
        unit_currency_value: 1,
        cus_id: "",
        currency_code: this.orgCurrency,
        amc_total: "",
        amc_tags: [],
        pdt_id: "",
        enable_auto_renewal: 0,
        amc_start_date: this.formatDate(new Date()),
        amc_end_date: "",
        next_service_date: "",
        repeat_every_day: "",
        repeat_every_cat: "",
        repeat_every: "",
        sales_person_id: "",
        ref_no: ""
      };
    },

    selectDate(val, field) {
      this.field[field] =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
      if (this.changed_currency && field == "amc_start_date") {
        this.getExchangeRateValue(1);
      }
    },
    //  get the customer created in modal and selected in dropdown
    getCustomerValue(event) {
      $("#customer_search input").css("position", "");
      $("#customer_remove").remove();
      this.field.cus_id = event.id;
      this.$refs.cus_name_typeahead.inputValue = event.cus_name;
      //  pass the details to place of supply modal
      this.checkpos({
        value: event.id,
        pos: event.pos,
        currency: event.cus_currency,
        tax_exempt: event.tax_exempt,
        payment_terms: event.cus_pymnt_term,
        buyer_gst_no: event.cus_gst_no,
        buyer_gst_type: event.cus_gst_type
      });
    },
    checkpos(event) {
      if (this.update_price == true) {
        this.customer_details = 0;
        //  design for selected customer inpout field

        $("#customer_search input").css("pointer-events", "none");
        $("#customer_search input").css("background-color", "#f7f7f7");
        $("#customer_search input").css("position", "relative");
        $("#customer_search .input-group").append(
          "<span class='la la-close p-2 mt-1 cursor_pointer bg-white' id='customer_remove'></span>"
        );
        $("#customer_remove").css("position", "absolute");
        $("#customer_remove").css("right", "0");
        this.field.cus_id = event.value; // assgin the selected customer id to cus id modal
        //  check for foreign currency
        if (event.currency != this.$AppDetails.organization.org_currency) {
          this.field.is_export = 2;
          this.field.place_of_supply = {
            label: this.getDetails(
              this.$AppDetails.state_details,
              "97",
              "state_name"
            ),
            value: 97
          };
        } else {
          this.field.is_export = 1;
          this.field.place_of_supply = {
            label: this.getDetails(
              this.$AppDetails.state_details,
              event.pos,
              "state_name"
            ),
            value: event.pos
          };
        }
        this.field.cus_currency = event.currency;
        this.getExchangeRateValue(0);
      }
    },
    //To remove row
    removeRow(index) {
      var i;
      if (typeof this.items[parseInt(index) + 1] != "undefined") {
        for (i = index; i < this.items.length - 1; i++) {
          var pdt_name = "pdt_name_typeahead_" + i;
          this.$refs[pdt_name][0].inputValue = this.items[
            i + 1
          ].productDetails.label;
          // this.$refs[pdt_name][0].inputValue = this.items[i + 1].pdt_detail_id;
          if (this.items[i + 1].pdt_detail_id == "") {
            $("#product_search_" + i + " input").css("pointer-events", "all");
            $("#product_search_" + i + " input").css(
              "background-color",
              "#fff"
            );
            $("#product_search_" + i + " input").css("position", "");
            $("#product_remove_" + i).remove();
          }
        }
      }
      if (this.items.length > 1) {
        this.items.splice(index, 1);
      }
    },
    //Remove product
    removeproduct(e, index) {
      if (e.target.matches("#product_remove_" + index)) {
        $("#product_search_" + index + " input").css("pointer-events", "all");
        $("#product_search_" + index + " input").css(
          "background-color",
          "#fff"
        );
        $("#product_search_" + index + " input").css("position", "");
        $("#product_remove_" + index).remove();
        var pdt_name = "pdt_name_typeahead_" + index;
        this.$refs[pdt_name][0].inputValue = "";
        this.items[index].pdt_id = "";
        this.items[index].pdt_desc = "";
        this.items[index].pdt_hsn = "";
        this.items[index].sale_price = "";
        this.items[index].purchase_price = "";
      }
    },
    total() {
      var total_pdt_qty = 0;
      //  calculating the total without tax
      var total = this.items.reduce(function(total, value) {
        if (value.pdt_id != "") {
          //  get pdt qty
          var pdt_qty =
            !isNaN(value.pdt_qty) && value.pdt_qty != ""
              ? parseFloat(value.pdt_qty)
              : 0;
          value.sale_price = parseFloat(
            parseFloat(pdt_qty) * parseFloat(value.unit_price)
          ).toFixed(2);
          total_pdt_qty += parseFloat(pdt_qty);
        }
        return !isNaN(parseFloat(value.sale_price))
          ? total + parseFloat(value.sale_price)
          : parseFloat(total);
      }, 0);
      return {
        total: total.toFixed(2),
        total_pdt_qty: total_pdt_qty.toFixed(2)
      };
    },

    addNewRow() {
      this.items.push({
        pdt_used_qty: 0,
        amc_itm_id: "",
        pdt_hsn: "",
        unit_name: "",
        pdt_desc: "",
        pdt_detail_id: "",
        products: [],
        pdt_id: "",
        pdt_qty: 1,
        unit_price: 0,
        sale_price: 0,
        purchase_price: 0
      });
    },
    updateFields() {
      this.field = this.list.header_details; // assigning header value to the fiels datas
      this.old_cus_id = this.field.cus_id;
      this.old_currency_code = this.field.currency_code;
      this.old_exchange_rate = this.field.unit_currency_value;
      this.changed_currency = false;
      this.old_amc_itm_ids = this.list.old_amc_itm_ids;
      this.field.pdt_id = this.list.header_details.amc_pdt_id;
      var day =
        this.list.header_details.repeat_every_day +
        " " +
        this.list.header_details.repeat_every_cat;
      this.field.repeat_every = day;

      var check = this.getPresentValue(
        this.repeat_every,
        "value",
        day,
        "label"
      );

      if (
        check == "" &&
        this.list.header_details.repeat_every_cat != "" &&
        this.list.header_details.repeat_every_cat != null
      ) {
        this.field.repeat_every = 1;
        this.recurring_period({
          target: {
            value: 1
          }
        });
      }
      //  item details
      this.items = this.list.item_details;
    }
  },
  watch: {
    cus_id(val) {
      if (val != "" && val.length > 2) {
        var data = {
          search_value: val,
          search_column: this.search_column
        };
        this.$store
          .dispatch("general/fetchCustomerAdvanceSearchData", data)
          .then(() => {
            this.customers = this.customer_filter_list;
          });
      }
    }
  },
  async created() {
    this.field.exchange_rate_status = this.org_details.exchange_rate_status;
    for (var i = 0; i < this.amc_settings_details.custom_field.length; i++) {
      if (this.amc_settings_details.custom_field[i].status == 1 && this.amc_settings_details.custom_field[i].permissions == 'write') {
        this.$set(
          this.field,
          this.amc_settings_details.custom_field[i].field_name,
          this.amc_settings_details.custom_field[i].default_value
        );
      }
    }

    if (this.page == "update") {
      this.currency_details = {};
      document.title = getPageTitle(
        this.list.header_details.amc_no + " | " + this.$route.meta.title
      );
      await this.updateFields();
    } else {
      this.update_price = true;
    }
    //  to watch any updates in field data
    await this.$watch(
      "field",
      function() {
        this.$emit("FormUpdate");
      },
      {
        deep: true
      }
    );
    //  to watch any updates in item data
    await this.$watch(
      "items",
      function() {
        this.$emit("FormUpdate");
      },
      {
        deep: true
      }
    );
    if (this.$route.query.customer_id) {
      this.field.cus_id = this.$route.query.customer_id;
      this.update_price = await true;
      await this.getCustomerValue({
        id: this.customer_data.cus_id,
        cus_name: this.customer_data.cus_display_name,
        pos: this.customer_data.place_of_supply,
        tax_exempt: this.customer_data.tax_exempt,
        cus_pymnt_term: this.customer_data.cus_pymnt_term,
        cus_currency: this.customer_data.cus_currency,
        cus_gst_no: this.customer_data.cus_gst_no,
        cus_gst_type: this.customer_data.cus_gst_type,
        cus_pan_no: this.customer_data.cus_pan_no,
        credit_limit: this.customer_data.credit_limit,
        pricing_hdr_id: this.customer_data.pricing_hdr_id
      });
    }
  },
  updated: function() {
    this.$nextTick(function() {
      if (this.update_price == false) {
        //update prodcut price

        var i;
        for (i = 0; i < this.items.length; i++) {
          var pdt_name = "pdt_name_typeahead_" + i;
          this.$refs[pdt_name][0].inputValue = this.items[i].products[i].label;
          $("#product_search_" + i + " input").css("pointer-events", "none");
          $("#product_search_" + i + " input").css(
            "background-color",
            "#f7f7f7"
          );
          $("#product_search_" + i + " input").css("position", "relative");
          $("#product_search_" + i + " .input-group").append(
            "<span class='la la-close cursor_pointer bg-white pdt-close' id='product_remove_" +
              i +
              "'></span>"
          );
          $("#product_remove_" + i).css("position", "absolute");
          $("#product_remove_" + i).css("right", "0");
          $("#product_remove_" + i).css("padding", "10px 6px");
        }
        var cus_name = this.list.header_details.cus_name;

        this.cus_id = cus_name;
        this.$refs.cus_name_typeahead.inputValue = cus_name;
        $("#customer_search input").css("pointer-events", "none");
        $("#customer_search input").css("background-color", "#f7f7f7");
        $("#customer_search input").css("position", "relative");
        $("#customer_search .input-group").append(
          "<span class='la la-close p-2 mt-1 cursor_pointer bg-white' id='customer_remove'></span>"
        );
        $("#customer_remove").css("position", "absolute");
        $("#customer_remove").css("right", "0");
        this.update_price = true;
      }
    });
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      customer_list: state => state.sales.customer_list,
      message: state => state.amccontract.message,
      sales_person_list: state => state.amccontract.sales_person_list,
      customer_filter_list: state => state.general.customer_filter_list,
      tag_list: state => state.amccontract.tag_list,
      product_filter_list: state => state.general.product_filter_list,
      amc_pdt_list: state => state.amccontract.amc_pdt_list,
      service: state => state.amccontract.items,
      serviceTotal: state => state.amccontract.serviceTotal,
      list: state => state.amccontract.list,
      updatedtag_id: state => state.sales.updatedtag_id,
      updated_tag: state => state.amccontract.updated_tag,
      exchange_rate_message: state => state.currency.message,
      exchange_rate_type: state => state.currency.type,
      customer_data: state => state.customer.listView.main_detail,
       status_code: state => state.amccontract.status_code, 
      status_message: state => state.amccontract.status_message, 
      status_type: state => state.amccontract.status_type
    }),
    currency_details: {
      get() {
        return this.$store.state.customer.currency_details;
      },
      set(val) {
        this.$store.state.customer.currency_details = val;
      }
    },
    ...mapGetters(["amc_settings_details", "orgCurrency", "org_details"]),

    next_renewal_date() {
      if (
        this.field.amc_end_date &&
        this.field.repeat_every_day &&
        this.field.repeat_every_cat
      ) {
        return (
          "Renewal On :" +
          this.getDateFormat(
            moment(this.field.amc_end_date).add(
              this.field.repeat_every_day,
              this.field.repeat_every_cat + "s"
            )
          )
        );
      }
    }
  }
};
</script>
<style scoped>
.tags {
  height: 30px !important;
}
.name {
  max-width: 295px;
}
.date {
  max-width: 295px;
}
.select_tag {
  max-width: 670px;
  margin-left: 14px;
}
.amcrepeat {
  max-width: 900px;
}
.amcform {
  max-width: 900px;
}

@media screen and (max-width: 800px) {
  .select_tag {
    max-width: 545px;
    margin-left: -11px;
  }
  .amcform {
    max-width: 800px;
  }

  .date {
    width: 208px;
    margin-left: 0px;
  }
  .name {
    max-width: 206px;
    margin-left: -18px;
  }
  .account {
    margin-left: 0px;
    max-width: 206px;
  }
  .acc_label {
    margin-left: -63px;
  }
}
</style>
<style scoped>
.create-cus {
  margin-right: 20px !important;
  height: 29px;
  margin-top: 0px !important;
}

.customer_search {
  width: 600px;
}
</style>